import { RootState } from '../store'

export const selectPractisingAol = (state: RootState): string => {
  return state.user?.practisingAol ?? ''
}
